import { UncontrolledCollapse, Table, Col, Container, Row, Card, CardBody, Input, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, Form, ModalBody, ModalFooter, Label, ModalHeader, FormFeedback, Spinner, CardHeader, CardFooter } from "reactstrap";
import { isEmpty, clone } from "lodash";
import logo from "../../../../assets/images/users/user-dummy-img.jpg";
import { api } from "../../../../config";
import { Link } from "react-router-dom";
import defaultImg from "../../../../assets/images/users/user-dummy-img.jpg";
import moment from "moment";
import parse from "html-react-parser";
import Flatpickr from "react-flatpickr";
import handleValidDate from "../../../../helpers/utils/handleValidDate";
import handleValidDateTime from "../../../../helpers/utils/handleValidDateTime";
import { useEffect, useState } from "react";
const CardBoard = (props) => {
  useEffect(() => {
    if (props.isLoadingDeal === false) {
      props.handleSubmitLoading(null);
    }
  }, [props.isLoadingDeal]);
  const sendDataToParent = () => {
    let datas = [];
    props.data.deal_user.forEach((item) => {
      datas.push({ label: item.deal_user_user.name, value: item.deal_user_user.id });
    });
    const updateDealPatch = {
      id: props.data ? props.data.id : 0,
      image: props.data.image,
      description: "",
      value: props.data.value,
      tag: JSON.stringify(props.data.tag),
      statusId: props.data.statusId,
      customerId: props.data.customerId,
      brandId: props.data.brandId,
      branchId: props.data.branchId,
      companyId: props.data.companyId,
      clientId: props.data.clientId,
      files: props.data.deal_file,
      startat: props.data.startat,
      endat: props.data.endat,
      dealuser: datas,
      name: props.data.name,
      statusDealId: props.data.statusDealId,
      deal_product: JSON.stringify(props.data.deal_product),
      action: "tanggal_akad",
    };
    props.handleSubmitLoading(updateDealPatch.id);
    props.onChildProps(updateDealPatch);
  };
  let history = props.history;
  const handleEndAt = (date) => {
    props.data.endat = date;
  };

  return (
    <>
      <Card
        className="mb-2 border-1"
        style={{
          border: "1px solid rgb(204, 204, 204)",
          whiteSpace: "normal",
        }}
      >
        <CardBody>
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <img
                style={{
                  pointerEvents: "none",
                }}
                src={props.image === "" ? logo : `${api.MEDIA_URL}/media/${props.image}`}
                alt=""
                className="avatar-xs rounded-circle"/>
            </div>
            <div className="flex-grow-1 ms-3">
              <div className="mb-1">
                <h6 className="fs-14 mb-1 user-select-none">{props.customer}</h6>
                {/* <p className="text-muted mb-0 user-select-none">{`${props.startat} - ${props.endat}`}</p> */}
              </div>
              {props.dealUser.length > 0 ? (
                <div className="d-flex flex-wrap gap-2">
                  {props.dealUser.map((el, i) => {
                    return (
                      <span key={i} className="badge text-uppercase badge-soft-success">
                        {el.deal_user_user.name}
                      </span>
                    );
                  })}
                </div>
              ) : null}
              {props.data.status_bank != null ? (
                <div className="mt-1">
                  <p>{props.data.status_bank}</p>
                </div>
              ) : null}

              {parseInt(props.data.statusDealId) > 2 && (
                <div className="d-flex flex-wrap gap-2">
                  {props.data.deal_book.map((el, i) => {
                    let data = {
                      id: props.data.id,
                      type: "Status",
                      companyId: props.data.companyId,
                      clientId: props.data.clientId,
                      statusDealId: props.data.statusDealId,
                    };
                    let obj = {
                      deal_customer: props.data.deal_customer,
                    };
                    return (
                      <span
                        key={i} onClick={() => {
                          props.handleToggleBooking(data, props.data);
                        }}
                        className="cursor-pointer fs-12 mt-2">
                        [ View Book Receipt ]
                      </span>
                    );
                  })}
                </div>
              )}
              {props.data.statusDealId === 6 ? (
                <div>
                  <Label htmlFor="des-field" className="form-label">
                    Tanggal Akad
                  </Label>
                  <Flatpickr
                    name="date-picker"
                    className="form-control"
                    placeholder="Select end date"
                    options={{
                      enableTime: true,
                      altInput: true,
                      altFormat: "Y/m/d H:i",
                      dateFormat: "Y/m/d H:i",
                      time_24hr: true,
                    }}
                    value={props.data.endat ?? ""}
                    onChange={(obj, str) => {
                      handleEndAt(str);
                    }}/>
                  <button disabled={props.idCard === parseInt(props.data.id) ? true : false} onClick={sendDataToParent} className="btn btn-info btn-sm mt-2">
                    <span className="d-flex align-items-center justify-content-center">
                      <span className="me-2">Submit</span>
                      {props.idCard === parseInt(props.data.id) && props.isLoadingDeal && (
                        <Spinner size="sm" role="status">
                          Loading...
                        </Spinner>
                      )}
                    </span>
                  </button>
                </div>
              ) : null}

              {props.data.statusDealId === 7 && (
                <div className="">
                  <div className="fw-bold">Tanggal Akad</div>
                  <span
                    // key={i}

                    className="cursor-pointer fs-12 mt-2"> 
                    {handleValidDateTime(props.data.endat)}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* <i className="mdi mdi-chevron-down ms-1"></i> */}
        </CardBody>
        <CardFooter className="d-flex gap-2 justify-content-between">
          <Button
            color="light"
            onClick={() => {
              let data = {
                // ...object,
                id: props.data.id,
                type: "Status",
                companyId: props.data.companyId,
                clientId: props.data.clientId,
                statusDealId: props.data.statusDealId,
              };

              props.handleToggleSubmitDoc(data, props.data);
            }}
            className="btn-sm"
            style={{
              width: "60px",
            }}><i className="ri-attachment-line align-bottom me-1"></i>
          </Button>
          {/* <Button
            onClick={() => {
              props.handleFollowUpClick(props.data);
            }}
            color="light"
            className="btn-sm"
            style={{
              width: "50px",
            }}><i className="ri-question-answer-line align-bottom me-1"></i> 
          </Button> */}
          <Button
            onClick={() => {
              props.handleContactClick(props.data);
            }}
            color="light"
            className="btn-sm"
            style={{
              width: "60px",
            }}><i className="ri-pencil-line align-bottom me-1"></i> 
          </Button>

          <Link
            color="light"
            style={{
              width: "60px",
            }}
            to="#"
            id={"leadInnerDiscovered" + props.id}><Button
              color="info"
              className="btn-sm"
              style={{
                width: "60px",
              }}>
              <i className="ri-eye-line align-bottom me-1"></i> 
            </Button>
          </Link>
        </CardFooter>
        <UncontrolledCollapse className="border-top border-top-dashed" toggler={"#leadInnerDiscovered" + props.id} defaultOpen={false}>
          <CardBody className="bg-light ">
            {/* <div className="d-flex flex-wrap mb-2 gap-2">
              <span  className="badge text-uppercase badge-soft-success">
                afsafs fdsdf
              </span>
              <span  className="badge text-uppercase badge-soft-success">
                afsafs fdsdf
              </span>
            </div> */}

            {props.dealProduct.length > 0 ? (
              <ul style={{ paddingLeft: "10px" }}>
                {props.dealProduct.map((el, i) => {
                  return <li key={i}>{el.deal_product_product.name}</li>;
                })}
              </ul>
            ) : null}
            {props.description !== "-" && <p>{parse(props.description)}</p>}
            <div className="timeline-2">
              <div className="timeline-continue">
                {props.history.map((el, i) => {
                  const startAt = handleValidDate(el.startat);
                  return (
                    <Row key={el.id} className="timeline-right">
                      <Col xs={12}>
                        <p className="timeline-date">{`${startAt}`}</p>
                      </Col>
                      <Col xs={12}>
                        {el.type === "Status" ? (
                          <div className="timeline-box-s bg-warning">
                            <div className="timeline-text">{el.deal_history_status === null ? "" : el.deal_history_status.name}</div>
                          </div>
                        ) : (
                          <div className="timeline-box">
                            <div className="timeline-text">
                              <span key={i} className={`badge text-uppercase badge-soft-${el.type === "Follow Up" ? "info" : "success"} mb-2`}>
                                {el.type}
                              </span>
                              <p className="text-muted mb-0">{el.description === null ? "" : el.description}</p>
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  );
                })}
              </div>
            </div>
          </CardBody>
        </UncontrolledCollapse>
      </Card>
    </>
  );
};

export default CardBoard;
